module.exports = __webpack_public_path__ + "static/media/chimney.57b143c4.svg";